import { Menu, type MenuGroupProps, Text } from "@overmap-ai/blocks"
import { UNLABELLED_ASSET_LABEL } from "@overmap-ai/common"
import type { Asset, Stored } from "@overmap-ai/common"
import { memo } from "react"

import { AssetTypeIcon } from "../Icons/AssetTypeIcon"
import { AssetIndexLabel } from "../IndexLabels/AssetIndexLabel"

export interface AssetGroupProps extends MenuGroupProps {
	assets: Stored<Asset>[]
	onSelectAsset: (asset: Stored<Asset>) => void
}

export const AssetGroup = memo<AssetGroupProps>((props) => {
	const { ref, assets, onSelectAsset, ...rest } = props

	return (
		<Menu.Group ref={ref} {...rest}>
			{assets.map((asset) => {
				return (
					<Menu.Item key={asset.uuid} onSelect={() => onSelectAsset(asset)}>
						<AssetTypeIcon assetTypeId={asset.asset_type} inline />
						<AssetIndexLabel className="truncate whitespace-nowrap" assetId={asset.uuid} />
						<Text className="truncate" accentColor="base">
							{asset.label || UNLABELLED_ASSET_LABEL}
						</Text>
					</Menu.Item>
				)
			})}
		</Menu.Group>
	)
})
AssetGroup.displayName = "AssetGroup"
